import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
